export class IteratorUtility<T> {
  private __iterable: IterableIterator<T>;
  private __current: IteratorResult<T>;

  constructor(arr: T[]) {
    this.__iterable = arr[Symbol.iterator]();
    this.__current = this.__iterable.next();
  }

  get currentValue(): T {
    return this.__current.value;
  }

  get isDone(): boolean {
    return !!this.__current.done;
  }

  next(): T {
    this.__current = this.__iterable.next();
    return this.__current.value;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/types/iterator.ts